export default __webpack_public_path__ + "static/ProValue_4@992-9de26e2424612c77bf9778b68fadd6df.png";